export const DRAWER_MENU_OPTIONS = {
    DRAWER_MENU_OPTIONS_SET_SELECTED: "DRAWER_MENU_OPTIONS_SET_SELECTED",
    DRAWER_MENU_OPTIONS_CLEAR_SELECTED: "DRAWER_MENU_OPTIONS_CLEAR_SELECTED",
  };
  